import { render, staticRenderFns } from "./MarketingCostsTabs.vue?vue&type=template&id=71eef0cf&scoped=true"
import script from "./MarketingCostsTabs.vue?vue&type=script&lang=js"
export * from "./MarketingCostsTabs.vue?vue&type=script&lang=js"
import style0 from "./MarketingCostsTabs.vue?vue&type=style&index=0&id=71eef0cf&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eef0cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71eef0cf')) {
      api.createRecord('71eef0cf', component.options)
    } else {
      api.reload('71eef0cf', component.options)
    }
    module.hot.accept("./MarketingCostsTabs.vue?vue&type=template&id=71eef0cf&scoped=true", function () {
      api.rerender('71eef0cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/StoryMode/FinancialPlan/Components/Expenses/MarketingCost/MarketingCostsTabs.vue"
export default component.exports